// The section segment only picks which group opens; as a crumb it would render its raw kebab-case slug.
export const settingsBreadcrumbName = (section?: string) => (pathComponent: string) =>
	pathComponent === section ? null : `${pathComponent[0].toLocaleUpperCase()}${pathComponent.substring(1)}`;
